import BaseStore from '../BaseStore';
import axios from 'axios';

const MapStore = {
    ...BaseStore,
    loadMarkers: async function() {
        try {
            startModalSpinner();
            const response = await axios.get(this.getProperty('mapDataRoute'), { params: this.getProperty('filterParams')});
            const results = response.data;
            if (results.success == true) {
                this.state.items = results.complaints;
                this.emitEvent('changeMarkers', this.state.items.map((x) => {x.isOpen = false; return x;}));
            } else {
                stopModalSpinner();
                showErrorMessage(results.message?results.message:'Error', true, 2000, true);
            }
        } catch (error) {
            stopModalSpinner();
            showErrorMessage(error.response.data.error?error.response.data.error:'Error', true, 2000, true);
        }
    },
}
//set default popup
MapStore.setProperty('filterParams', {status: '', category: '', from: '', to: ''});
MapStore.setProperty('selectedItem', {id: 0, coords: '22.1212121,47.32432432', status: '', status_text: '', resolution_text: '', created_at: '', message: '', isOpen: false});
export default MapStore;
